import script from "./Accordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=ts"

import "./Accordion.vue?vue&type=style&index=0&id=561efddd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561efddd"]])

export default __exports__